// extracted by mini-css-extract-plugin
export default {"wrap":"EH-z","fullWidth":"FH-z","hideOnDesktop":"GH-z","content":"HH-z","hasOpenedNav":"IH-z","crumbsList":"JH-z","dropdownsWrap":"KH-z"};